<div>
    <h5 class="text-s text-center"><strong>Experian Credit Report</strong></h5>
    
    <div class="row mt-3 mb-3">
        <div class="col-6 text-start">
            <label class="form-label text-xs fw-bold">ID Number <span class="text-danger fw-bold">*</span></label>
            <input 
                v-model="id_number" 
                type="text" 
                class="form-control text-xs rounded-small p-3 shadow-sm" 
                placeholder="Enter ID Number"
                maxlength="13"
                @input="allow_number">
            <small class="text-danger fw-bold text-xs d-none id-number-message">
                Please fill in this field
            </small>
            <small class="text-danger fw-bold text-xs d-none id-length-message">
                ID Number must be 13 digits
            </small>
            <small class="text-danger fw-bold text-xs d-none id-invalid-message">
                Invalid ID Number
            </small>
        </div>
        <div class="col-6 text-start">
            <label class="form-label text-xs fw-bold">First Name <span class="text-danger fw-bold">*</span></label>
            <input 
                v-model="first_name" 
                type="text" 
                class="form-control text-xs rounded-small p-3 shadow-sm" 
                placeholder="Enter First Name">
            <small class="text-danger fw-bold text-xs d-none first-name-message">
                Please enter a valid first name
            </small>
        </div>
    </div>

    <div class="row mt-2 mb-3">
        <div class="col-6 text-start">
            <label class="form-label text-xs fw-bold">Surname <span class="text-danger fw-bold">*</span></label>
            <input 
                v-model="surname" 
                type="text" 
                class="form-control text-xs rounded-small p-3 shadow-sm" 
                placeholder="Enter Surname">
            <small class="text-danger fw-bold text-xs d-none surname-message">
                Please enter a valid surname
            </small>
        </div>
        <div class="col-6 text-start">
            <label class="form-label text-xs fw-bold">Gender <span class="text-danger fw-bold">*</span></label>
            <select 
                v-model="gender" 
                class="form-select text-xs rounded-small p-3 shadow-sm">
                <option disabled value="">Select Gender</option>
                <option value="M">Male</option>
                <option value="F">Female</option>
            </select>
            <small class="text-danger fw-bold text-xs d-none gender-message">
                Please select a gender
            </small>
        </div>
    </div>

    <div class="row mt-2 mb-3">
        <div class="col-6 text-start">
            <label class="form-label text-xs fw-bold">Date of Birth <span class="text-danger fw-bold">*</span></label>
            <input 
                v-model="date_of_birth" 
                type="date" 
                class="form-control text-xs rounded-small p-3 shadow-sm">
            <small class="text-danger fw-bold text-xs d-none dob-message">
                Please enter date of birth
            </small>
            <small class="text-danger fw-bold text-xs d-none dob-mismatch-message">
                Date of birth does not match the date in ID Number
            </small>
        </div>
    </div>

    <div class="col text-end">
        <button 
            type="submit" 
            class="btn bg-green btn-sm text-xs shadow rounded-small mt-2 fw-bold" 
            @click.prevent="submit_form">
            Submit
        </button>
    </div>
</div>
